// TODO: update these constants when we have data for Spring 2021
export const GOOGLE_CLASSROOM_DEFAULT_TERM_YEAR = 'Fall SY20-21';
export const GOOGLE_HANGOUT_DEFAULT_TERM_YEAR = 'Fall SY20-21';
